import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  ReferenceLine,
} from "recharts";
import { GRAPH_COLORS } from "../../../types/micellinous-constants";

const renderCustomBarLabel = ({ x, y, width, height, value, category }) => {
  const xPosValue = x + width / 2;
  const yPosValue = "80%";
  const xPosCategory = x - 5;
  const yPosCategory = 120;
  const fontSize = "0.5em";

  return (
    <>
      <text
        x={xPosValue}
        y={yPosValue}
        fill="#fff"
        fontSize={fontSize}
        textAnchor="middle"
        dominantBaseline="central"
      >
        {`${value}%`}
      </text>
      <text
        x={xPosCategory}
        y={yPosCategory}
        fill="#666"
        fontSize={fontSize}
        textAnchor="middle"
        dominantBaseline="central"
        transform={`rotate(-90, ${xPosCategory}, ${yPosCategory})`}
      >
        {category}
      </text>
    </>
  );
};

const HHGraph = ({ data, timeLabels, groupBy }) => {
  const formatGraphData = () => {
    const graphData = timeLabels.map((label) => ({ timeLabel: label }));

    data.forEach((categoryData) => {
      Object.keys(categoryData.timeData).forEach((timeLabel) => {
        const dataIndex = graphData.findIndex(
          (data) => data.timeLabel === timeLabel
        );
        const { compliant, missed, total } = categoryData.timeData[timeLabel];

        const compliantPercentage = (compliant / total) * 100;
        const missedPercentage = (missed / total) * 100;
        const nonCompliantPercentage =
          100 - compliantPercentage - missedPercentage;

        graphData[dataIndex][`${categoryData.item} Compliant`] = parseFloat(
          compliantPercentage.toFixed(1)
        );
        graphData[dataIndex][`${categoryData.item} Non-Compliant`] = parseFloat(
          nonCompliantPercentage.toFixed(1)
        );
        graphData[dataIndex][`${categoryData.item} Missed`] = parseFloat(
          missedPercentage.toFixed(1)
        );
      });
    });

    return graphData;
  };

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <span
          style={{
            color: "#4B5320",
            marginRight: "5px",
            marginLeft: "10px",
            display: "inline-block",
            width: "10px",
            height: "10px",
            backgroundColor: GRAPH_COLORS[0],
            borderRadius: "50%",
          }}
        ></span>
        <span>Compliant</span>
        <span
          style={{
            color: "orange",
            marginRight: "5px",
            marginLeft: "10px",
            display: "inline-block",
            width: "10px",
            height: "10px",
            backgroundColor: GRAPH_COLORS[1],
            borderRadius: "50%",
          }}
        ></span>
        <span>Non-Compliant</span>
        <span
          style={{
            color: "orange",
            marginRight: "5px",
            marginLeft: "10px",
            display: "inline-block",
            width: "10px",
            height: "10px",
            backgroundColor: GRAPH_COLORS[2],
            borderRadius: "50%",
          }}
        ></span>
        <span>Missed</span>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={formatGraphData()}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
            padding: 10,
          }}
          barSize={30}
          barGap={20}
        >
          <CartesianGrid strokeDasharray="1 5" />
          <XAxis dataKey="timeLabel" />
          <YAxis
            domain={[0, 100]}
            ticks={[0, 20, 40, 60, 80, 100]}
            label={{ value: "Compliance", angle: -90, position: "insideLeft" }}
          />
          <Tooltip />

          {data.map((item, index) => (
            <React.Fragment key={item.item}>
              <Bar
                key={`${item.item} Compliant`}
                dataKey={`${item.item} Compliant`}
                stackId={item.item}
                fill={GRAPH_COLORS[0]}
              >
                <LabelList
                  dataKey={`${item.item} Compliant`}
                  content={(props) =>
                    renderCustomBarLabel({
                      ...props,
                      category: item.item,
                      isFirst: index === 0,
                    })
                  }
                />
              </Bar>
              <Bar
                key={`${item.item} Non-Compliant`}
                dataKey={`${item.item} Non-Compliant`}
                stackId={item.item}
                fill={GRAPH_COLORS[1]}
              />
              <Bar
                dataKey={`${item.item} Missed`}
                stackId={item.item}
                fill={GRAPH_COLORS[2]}
              />
            </React.Fragment>
          ))}
          <ReferenceLine y={80} stroke="#DC143C" strokeDasharray="4 1" />
          <ReferenceLine y={90} stroke="#6495ED" strokeDasharray="4 1" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default HHGraph;
